module.exports = __webpack_public_path__ + "media/images/emblems/Bargen-coat_of_arms-750d4aad12656beefdec1c387b8845dc.svg";